import { APIS } from "../utils/constants/SYSTEM";

/**
 * @param {String} type "base" || "widget" || "crm" || "admin"
 * @param {String} environment "production" || "development" || "local"
 * @returns Object
 */
export function config(type, environment) {
  return APIS[type.toUpperCase()][environment.toUpperCase()];
}
